export default __webpack_public_path__ + "static/media/MU.0a02df07.svg";